import { supabase } from "@/lib/supabase/supabaseClient"
import { AddSurveyToSurveyBankProps } from "."

export const addSurveyToSurveyBank = async (props: AddSurveyToSurveyBankProps) => {
    return await supabase
        .from('survey_bank')
        .insert(props)
        .select()
        .throwOnError()
        .then(res => res.data?.[0]);
}